import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var SettingsFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M8.05664 1.6665L7.64648 3.76937C6.96252 4.028 6.33009 4.38934 5.77474 4.84521L3.75488 4.1486L1.81152 7.51774L3.42773 8.92236C3.37043 9.27399 3.33333 9.63202 3.33333 9.99984C3.33333 10.3677 3.37043 10.7257 3.42773 11.0773L1.81152 12.4819L3.75488 15.8511L5.77474 15.1545C6.33009 15.6103 6.96252 15.9717 7.64648 16.2303L8.05664 18.3332H11.9434L12.3535 16.2303C13.0375 15.9717 13.6699 15.6103 14.2253 15.1545L16.2451 15.8511L18.1885 12.4819L16.5723 11.0773C16.6296 10.7257 16.6667 10.3677 16.6667 9.99984C16.6667 9.63202 16.6296 9.27399 16.5723 8.92236L18.1885 7.51774L16.2451 4.1486L14.2253 4.84521C13.6699 4.38934 13.0375 4.028 12.3535 3.76937L11.9434 1.6665H8.05664ZM10 6.6665C11.8408 6.6665 13.3333 8.159 13.3333 9.99984C13.3333 11.8407 11.8408 13.3332 10 13.3332C8.15917 13.3332 6.66667 11.8407 6.66667 9.99984C6.66667 8.159 8.15917 6.6665 10 6.6665Z",
    fill: fill
  }));
};
export { SettingsFilled as default };
//# sourceMappingURL=SettingsFilled.js.map
